import { IAssembly, IAssemblyListing } from 'src/interfaces';

export const getLayoutChannelName = (
  content: IAssembly | IAssemblyListing | undefined,
): string => {
  if (!content) return '';

  if ('layout_channel_name' in content) {
    return content.layout_channel_name ?? '';
  }

  return content.layout?.channel_name ?? '';
};

export const getLayoutTypeName = (
  content: IAssembly | IAssemblyListing | undefined,
): string => {
  if (!content) return '';

  if ('layout_type_name' in content) {
    return content.layout_type_name ?? '';
  }

  return content.layout?.layoutType?.name ?? '';
};

export const getIsDefaultAssembly = (
  content: IAssembly | IAssemblyListing | undefined,
): boolean | null => {
  if (!content) return null;

  if ('is_default_assembly' in content) {
    return content.is_default_assembly;
  }

  return null;
};

export const getScreenSetup = (
  content: IAssembly | IAssemblyListing | undefined,
): string => {
  if (!content) return '';

  if ('screen_setup' in content) {
    return content.screen_setup ?? '';
  }

  if ('screenSetup' in content) {
    return content.screenSetup ?? '';
  }

  return '';
};
